import Config from "../../config";
import { useSelector } from "react-redux";
import { RootState } from "src/store";
import { isProgramId } from "src/utility/utility";

export default function CurrentProgramHeader() {
  const programId = useSelector((state: RootState) => state.auth.programId);
  const curProgram = isProgramId(programId) ? Config[programId] : null;

  return (
    <div className="flex gap-4 items-center">
      <img
        className="w-16 h-16 object-contain"
        src={curProgram?.image}
        alt={curProgram?.name}
        onError={(e) => {
          if (!e.currentTarget.src.endsWith("logo192.png")) {
            e.currentTarget.src = "/logo192.png";
          }
        }}
      />
      <h2 className="text-2xl font-semibold">{curProgram?.name}</h2>
    </div>
  );
}
